import React, {useState, useCallback, useRef} from 'react';
import Modal from "../../components/modal/modal";
import styles from "../../lib/global.css";
import ButtonComponent from "../../../components/button/button";
import ErrorMsg from "../../components/error-msg/error-msg";

const HomeworkCommentModal = ({initRate, initComment, onClose, onSubmit,disabled=false}) => {
    const [rate, setRate] = useState(initRate);
    const comment = useRef(initComment);
    const [errorMsg, setErrorMsg] = useState('');
    const handleRateChange = useCallback((e) => {
        setRate(parseInt(e.target.value));
    }, []);
    const handleCommentChange = useCallback(e => {
        comment.current = e.target.value;
    }, []);
    return (
        <Modal
            onClose={onClose}
            title={disabled ? window.L('teach.lesson.commentedResult') : window.L('teach.lesson.homeworkComment')}
            >
            <div className={styles.antRow} style={{margin: "1rem"}}>
                <div className={styles.antCol4}>
                    {window.L("teach.homework.rate.A")}<input type="radio" value="10" checked={rate !== null && rate > 9} disabled={disabled} onChange={handleRateChange}/>
                </div>
                <div className={styles.antCol4}>
                    {window.L("teach.homework.rate.B")}<input type="radio" value="8" checked={rate !== null && rate >= 8 && rate < 10} disabled={disabled} onChange={handleRateChange}/>
                </div>
                <div className={styles.antCol4}>
                    {window.L("teach.homework.rate.C")}<input type="radio" value="6" checked={rate !== null && rate >= 6 && rate < 8} disabled={disabled} onChange={handleRateChange}/>
                </div>
                <div className={styles.antCol4}>
                    {window.L("teach.homework.rate.D")}<input type="radio" value="3" checked={rate !== null && rate >= 3 && rate < 6} disabled={disabled} onChange={handleRateChange}/>
                </div>
                <div className={styles.antCol6}>
                    {window.L("teach.homework.rate.E")}<input type="radio" value="1" checked={rate !== null && rate < 3} disabled={disabled} onChange={handleRateChange}/>
                </div>
            </div>
            <ErrorMsg errorMsg={errorMsg}/>
            <div className={styles.antRow}>
                <div className={styles.antCol}>
                    <textarea defaultValue={initComment} onChange={handleCommentChange} style={{
                        width: "333px",
                        height: "222px",
                        resize: "none",
                    }} disabled={disabled}>
                    </textarea>
                </div>

            </div>

            <div className={styles.antRow} style={{marginTop: "1rem"}}>
                <div className={styles.antCol24} style={{textAlign: "center"}}>
                    <ButtonComponent
                        className={styles.button}
                        style={{display: "inline-flex"}}
                        onClick={() => {
                            if (rate === null) {
                                setErrorMsg(window.L('teach.homework.noRate'));
                                return;
                            }
                            onSubmit({
                                rate,
                                comment: comment.current,
                            });
                        }}
                    >
                        {window.L('teach.button.submit')}
                    </ButtonComponent>
                </div>
            </div>


        </Modal>
    );
}

export default HomeworkCommentModal;
